<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/sites' }">sites</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/sites/${this.$route.params.siteId}` }"
        >Station
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- {{stationDetails}} Station-->
    <div class="row">
      <div class="col-lg-12 text-center">
        <div class="card-transparent">
          <h3 class="card-title text-center">
            Station Number: {{ stationDetails.station_number }}
          </h3>
          <h5 class="description">
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            {{ siteName }}, {{ siteAddress }}
          </h5>
        </div>
      </div>
      <!-- {{editConnectionModel}} -->
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="connectionCount.type"
          :icon="connectionCount.icon"
          :small-title="connectionCount.title"
          :title="connectionCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="connectionCount.footerIcon"></i>
            {{ connectionCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="bookingCount.type"
          :icon="bookingCount.icon"
          :small-title="bookingCount.title"
          :title="bookingCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="bookingCount.footerIcon"></i>
            {{ bookingCount.footerText }}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h3>Connections</h3>
      </div>
      <div class="col-md-4 offset-md-4">
        <p-button
          class="btn btn-success pull-right"
          @click="openModalAddConnection"
          v-if="hasConnectionAddPermission"
          >Add Connections</p-button
        >
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="connectionPagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in connectionPagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="connectionTableData"
              border
              size="medium"
              empty-text="Select a station to display connections"
              style="width: 100%"
            >
              <el-table-column
                v-for="column in connectionTableColumns"
                :key="column.label"
                align="center"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <!-- <el-tooltip content="Delete this station"
                                    placement="top">
                                    <p-button type="danger" size="sm" icon>
                                    <i class="fas fa-trash-alt"></i>
                                    </p-button>
                  </el-tooltip>-->
                  <el-tooltip content="Edit Connection" placement="top">
                    <p-button
                      type="warning"
                      size="sm"
                      icon
                      @click="handleEdit(props.$index, props.row)"
                      :disabled="hasConnectionEditPermission(props.row)"
                    >
                      <i class="fas fa-edit"></i>
                    </p-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="connectionPagination.currentPage"
              :per-page="connectionPagination.perPage"
              :total="connectionPagination.total"
              @input="connectionInputChanged($event)"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- add connection modal -->
    <modal
      :show.sync="addConnectionModal"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title">
        Add Connections for Station
        <span class="span-site-name">#{{ stationDetails.station_number }}</span>
        of Site
        <span class="span-site-name">{{ siteName }}</span>
      </h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input
              label="Number of Connections"
              type="number"
              name="numberOfConnectionToAdd"
              v-model="numberOfConnectionToAdd"
              :error="getError('numberOfConnectionToAdd')"
              v-validate="'required|min_value:1'"
            ></fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="addConnectionModal = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="addConnectionValidation"
          >Add Connections</p-button
        >
      </template>
    </modal>

    <!-- edit connection modal -->
    <modal
      :show.sync="editConnectionModal"
      footer-classes="justify-content-center"
      type="notice"
    >
      <!-- <h5 slot="header" class="text-primary modal-title">Edit Connections</h5> -->
      <h5 slot="header" class="text-primary modal-title">
        Edit Connection
        <span class="span-site-name">{{
          editConnectionModel.connection_point
        }}</span>
        for Station
        <span class="span-site-name">#{{ stationDetails.station_number }}</span>
        of Site
        <span class="span-site-name">{{ siteName }}</span>
      </h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input
              label="Station Number"
              name="stationNumber"
              v-model="editConnectionModel.station.station_number"
              disabled="true"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input
              label="Connection Point"
              name="connectionPoint"
              v-model="editConnectionModel.connection_point"
              disabled="true"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input :error="getError('type')">
              <label for="inputType">Connection Type</label>
              <!-- {{connectionTypes}} -->
              <select
                id="inputType"
                name="type"
                class="form-control"
                v-model="editConnectionModel.type"
                v-validate="'required'"
              >
                <option :value="null" disabled>Select Connection Type</option>
                <option
                  v-for="type in connectionTypes"
                  :value="type"
                  v-bind:key="type"
                >
                  {{ type }}
                </option>
              </select>
            </fg-input>
          </div>
          <div class="form-group">
            <!-- {{connectionStatus}} -->
            <fg-input :error="getError('status')">
              <label for="inputStatus"></label>
              <select
                id="inputStatus"
                name="type"
                class="form-control"
                v-model="editConnectionModel.status_id"
                v-validate="'required'"
              >
                <option :value="null" disabled>Select Status</option>
                <option
                  v-for="(value, name) in connectionStatus"
                  :value="value"
                  v-bind:key="value"
                >
                  {{ name }}
                </option>
              </select>
            </fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="editConnectionModal = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="editConnectionValidation"
          >Edit Connection</p-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import HTTP from "src/util/http-common.js";
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import { Tooltip } from "element-ui";
import Modal from "src/components/UIComponents/Modal.vue";
import swal from "sweetalert2";
import Vue from "vue";
import "vue-loading-overlay/dist/vue-loading.css";
import routes from "../../../../routes/routes";

export default {
  components: {
    StatsCard,
    [Tooltip.name]: Tooltip,
    Modal,
  },
  props: ["siteId", "stationId"],
  data() {
    return {
      user_permissions: null,
      stats: [],
      siteName: "",
      siteAddress: "",
      connectionCount: {
        type: "warning",
        icon: "fas fa-plug",
        title: "Connections",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      bookingCount: {
        type: "warning",
        icon: "fas fa-file-invoice",
        title: "Bookings",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      connectionPagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      connectionTableColumns: [
        {
          prop: "id",
          label: "UID",
          minWidth: 200,
        },
        {
          prop: "connection_point",
          label: "Connection Point",
          minWidth: 200,
        },
        {
          prop: "status_description",
          label: "Status",
          minWidth: 200,
        },
        {
          prop: "type",
          label: "Type",
          minWidth: 120,
        },
      ],
      tableData: [],
      connectionTableData: [],
      selectedStationId: null,
      addConnectionModal: false,
      numberOfConnectionToAdd: 1,
      stationDetails: {},
      editConnectionModel: {
        station: { station_number: null },
        connection_point: null,
        connection_id: null,
      },
      originalEditConnectionModel: {},
      editConnectionModal: false,
      connectionTypes: [],
      connectionStatus: [],
      sitePermissions: this.$store.getters["auth/sitePermissions"],
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.connectionPagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return (
        this.connectionPagination.perPage *
        (this.connectionPagination.currentPage - 1)
      );
    },
    total() {
      return this.connectionPagination.total;
    },
    hasConnectionAddPermission() {
      if (this.user_permissions.includes("site.station.connection.post")) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "connectionPagination.perPage": function (newVal, oldVal) {
      console.log("per page changed from ", oldVal, "to ", newVal);
      this.connectionPagination.currentPage = 1;
      // this.setBookings();
      this.setConnections();
    },
    editConnectionModal: function (newVal, oldVal) {
      this.$validator.errors.clear();
    },
    addConnectionModal: function (newVal, oldVal) {
      this.$validator.errors.clear();
    },
  },
  created() {
    this.user_permissions = localStorage.getItem("permissions");
    HTTP.get(`api/v1/site/`, {
      params: {
        site_id: this.siteId,
      },
    })
      .then((response) => {
        var data = response.data;
        this.siteName = data.name;
        this.siteAddress = data.address;
      })
      .catch((err) => {
        this.notifyVue(
          "Error getting site details.",
          err.response.data.message,
          "error"
        );
      });
    this.setConnections();
    this.setStationDetails();
  },
  methods: {
    back() {
      window.location.back();
    },
    inputChanged() {
      this.tableData = [];
      // this.setBookings();
      this.setStations();
    },
    connectionInputChanged() {
      this.connectionTableData = [];
      this.setConnections();
    },
    async fetchStationDetails() {
      const response = await HTTP.get("api/v1/site/station", {
        params: {
          station_id: this.stationId,
        },
      });
      const data = await response.data;
      return data;
    },
    setStationDetails() {
      this.fetchStationDetails()
        .then((data) => {
          this.stationDetails = data;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.$router.push({ name: "not-found" });
          } else if (err.response.status === 403) {
            this.$router.push({ name: "forbidden" });
          } else {
            this.notifyVue(
              "Error getting station details.",
              err.response.data.message,
              "error"
            );
          }
        });
    },
    async fetchConnectionList() {
      const response = await HTTP.get("api/v1/site/station/connection/list", {
        params: {
          site_id: this.siteId,
          station_id: this.stationId,
          page: this.connectionPagination.currentPage,
          page_size: this.connectionPagination.perPage,
          status: "all",
        },
      });
      const data = await response.data;
      return data;
    },
    setConnections() {
      this.connectionTableData = [];
      // let loader = this.$loading.show();
      this.fetchConnectionList()
        .then((data) => {
          const results = data.results;
          this.connectionTableData = results;
          this.connectionPagination.total = data.total;
          // loader.hide();
        })
        .catch((err) => {
          this.notifyVue(
            "Error getting booking stat",
            err.response.data.message,
            "error"
          );
          // loader.hide();
        });
    },
    rowClick(row, column, event) {
      this.selectedStationId = row.id;
      this.setConnections();
    },
    getConnectionCount() {
      HTTP.get("api/v1/dashboard/data", {
        params: {
          stat: "connection",
          site_id: this.siteId,
        },
      })
        .then((response) => {
          this.connectionCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.notifyVue(
            "Error getting connection stat",
            err.response.data.message,
            "error"
          );
        });
    },
    getBookingCount() {
      HTTP.get("api/v1/dashboard/data", {
        params: {
          stat: "booking",
          site_id: this.siteId,
        },
      })
        .then((response) => {
          this.bookingCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.notifyVue(
            "Error getting booking stat",
            err.response.data.message,
            "error"
          );
        });
    },
    openModalAddConnection() {
      this.addConnectionModal = true;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async addConnectionValidation() {
      const isValid = await this.$validator.validate("numberOfConnectionToAdd");
      console.log("isValid", isValid);
      if (isValid) {
        this.addConnectionAPI();
      }
    },
    addConnectionAPI() {
      var params = {
        station_id: parseInt(this.stationId),
        number_of_connections: parseInt(this.numberOfConnectionToAdd),
        site_id: this.siteId,
      };
      HTTP.post("api/v1/site/station/connection/list", params)
        .then((response) => {
          this.addConnectionModal = false;
          swal({
            title: "Successfully Added new Connection",
            text: response.data.message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
          this.setConnections();
        })
        .catch((err) => {
          this.addConnectionModal = false;

          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const reason = err.response.data.message;
            const status_code = err.response.status;
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code == 403) {
              this.$notify({
                group: "general",
                title: "Forbidden",
                text: err.response.data.message,
                type: "error",
              });
            } else {
              swal({
                title: error,
                text: reason,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: error.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: error.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },
    handleEdit(index, row) {
      this.setConnectionTypes();
      this.setConnectionStatus();
      console.log(index, row);
      this.editConnectionModel.station.station_number =
        this.stationDetails.station_number;
      this.editConnectionModel.connection_point = row.connection_point;
      this.editConnectionModel.connection_id = row.id;
      this.editConnectionModel.type = row.type;
      //    this.originalEditConnectionModel = Vue.util.extend({}, row);
      console.log(this.editConnectionModel, "edit");

      this.editConnectionModal = true;
    },
    async fetchConnectionTypes() {
      const response = await HTTP.get("api/v1/utils/connection/types", {});
      console.log(response, "response");
      const data = await response.data;
      return data;
    },
    setConnectionTypes() {
      this.fetchConnectionTypes().then((data) => {
        this.connectionTypes = data.types;
      });
    },
    async fetchConnectionStatus() {
      const response = await HTTP.get("api/v1/utils/connection/status", {});
      const data = await response.data;
      return data;
    },
    setConnectionStatus() {
      this.fetchConnectionStatus().then((data) => {
        this.connectionStatus = data;
      });
    },
    async editConnectionValidation() {
      const isValid = await this.$validator.validateAll();
      console.log("isValid", isValid);
      if (isValid) {
        this.editConnectionAPI();
      }
    },
    editConnectionAPI() {
      var params = {
        connection_id: this.editConnectionModel.connection_id,
        type: this.editConnectionModel.type,
        status_id: this.editConnectionModel.status_id,
        site_id: this.siteId,
      };
      HTTP.put("api/v1/site/station/connection", params)
        .then((response) => {
          this.editConnectionModal = false;
          swal({
            title: "Successfully Edited Connection",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
          this.setConnections();
        })
        .catch((err) => {
          this.editConnectionModal = false;
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const reason = err.response.data.message;
            const status_code = err.response.status;
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code == 403) {
              this.$notify({
                group: "general",
                title: "Forbidden",
                text: err.response.data.message,
                type: "error",
              });
            } else {
              swal({
                title: error,
                text: reason,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },
    hasConnectionEditPermission(row) {
      if (this.user_permissions.includes("site.station.connection.put")) {
        return false;
      } else {
        return true;
      }
    },
  },
  beforeDestroy() {
    this.connectionTableData = [];
  },
  mounted() {
    console.log(this.$route, "this.$route");
  },
};
</script>

<style scoped>
.span-site-name {
  text-transform: uppercase;
  color: #848484;
  white-space: nowrap;
}
</style>
